<template>
<Layout>
  <div class="section content">
    <h1 class="is-size-5">Imprint</h1>
    <span class="is-size-7">
      <p>
        778mobile GmbH<br>
        HRB 79227 // USt-IdNr: DE303966009<br>
        Mei Li-BERLIT, manager director<br>
        Wiesenstraße 21a2<br>
        DE-40549 Düsseldorf - Germany<br>
        E-Mail: <a href="mailto:cuca@778mobile.com">cuca@778mobile.com</a> <br>
      </p>
    </span>
  </div>
</Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Imprint',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/KE/Imprint.vue